import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { borderRadiusList } from './constants';

const generateRadius = (
	radius: keyof typeof borderRadiusList
) => `border-radius: ${borderRadiusList[radius]};
`;

export const Loader = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	width: 1.6rem;
	height: 1.6rem;
	opacity: 1 !important;
	transform: translate(-50%, -50%);
	& * {
		opacity: 1 !important;
	}
`;

export const styledButton = css`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border-color: var(--button-color-additional);
	backdrop-filter: blur(24px);

	background-color: var(--button-color-primary);
	color: var(--button-color-secondary);

	transition: background-color var(--button-transition-duration),
		color var(--button-transition-duration),
		border-color var(--button-transition-duration);

	&.disabled {
		cursor: default;
		pointer-events: none;
	}

	&.disabledInteraction {
		pointer-events: none;
	}

	&:not(.disabled) {
		cursor: pointer;
	}

	&.loading {
		position: relative;
		pointer-events: none;
		& * {
			opacity: 0;
		}
	}

	&.borderRadiusXXS {
		${generateRadius('XXS')}
	}

	&.borderRadiusXS {
		${generateRadius('XS')}
	}

	&.borderRadiusS {
		${generateRadius('S')}
	}

	&.borderRadiusM {
		${generateRadius('M')}
	}

	&.borderRadiusL {
		${generateRadius('L')}
	}

	&.borderRadiusXL {
		${generateRadius('XL')}
	}
`;

export const styledButtonBaseFullWidth = css`
	width: 100%;
`;
